<template>
  <select v-model="selectPrefecture" class="form_input" name="prefecture">
    <option value="0">都道府県を選択してください</option>
    <option v-for="(index, n) in prefectures" v-bind:value="index.prefectureId" :key="n">{{ index.prefectureName }}</option>
  </select>
</template>

<script>
import Prefecture from '@/components/api/prefecture'

export default {
  props: ['status', 'autoPrefectureId'],
  data() {
    return {
      selectPrefecture: 0,
      prefectures: [],
    }
  },
  methods: {
    apiGetPrefectureList() {
      Prefecture.getPrefectureList().then((val) => {
        console.log(val);
        this.prefectures.push(...val.prefectureList);
      });
      // this.$nextTick(function () {
      //   console.log('$nextTick');
      //
      // });

    }
  },
  async created() {
    // console.log('created');
    // setTimeout(() => {
    //   console.log('sleep');
    //   // ここに遅らせた後に行いたい処理を書く。関数でもOK
    //
    // }, 5000);
    await this.apiGetPrefectureList();

  },
  // mounted() {
  //   console.log('mounted');
  //   this.$nextTick(function() {
  //     console.log('$nextTick');
  //     var elems = document.getElementsByTagName('option');
  //     console.log(elems);
  //     this.apiGetPrefectureList();
  //   });
  // },
  watch: {
    selectPrefecture() {
      let data;
      if(this.selectPrefecture == 0) {
        data = { prefectureId: 0, prefectureName: '' };
      } else {
        data = this.prefectures[this.selectPrefecture - 1];
      }
      this.$emit('selectPrefecture', data);
    },
    status() {
      if(this.status) {
        this.selectPrefecture = 0;
      }
    },
    autoPrefectureId() {
      this.selectPrefecture = this.autoPrefectureId;
    }
  }
}
</script>

<style lang="css" scoped>
select, option {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PrefectureList.vue